import { MsalProvider } from '@azure/msal-react';
import 'moment/locale/sv';
import 'typeface-roboto';
import { authProvider } from './common/auth/authProvider';
import './index.css';
import { RestrictedApp } from './RestrictedApp';
import * as serviceWorker from './serviceWorker';

import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
    <StrictMode>
        <MsalProvider instance={authProvider}>
            <RestrictedApp />
        </MsalProvider>
    </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
